import { Injectable } from '@angular/core';
import { type SpotTimeSeriesData, type SpotType } from '@clean-code/models';
import { toDateOnly } from '@clean-code/shared/common';
import { GraphqlService } from '@clean-code/shared/util-graphql';

@Injectable({
  providedIn: 'root',
})
export class SettingSpotDataService {
  constructor(private graphqlService: GraphqlService) {}

  getSpotTimeSeriesDatas(
    spotConfigurationId: number,
    spotType: SpotType,
    date?: Date,
  ) {
    if (!date) {
      date = new Date(Date.now());
    }
    const query = `
      query ($spotConfigurationId: Int!, $spotType: SpotType!, $date: LocalDate) {
        spotTimeSeriesDatas(spotConfigurationId: $spotConfigurationId, spotType: $spotType, date: $date) {
        identifier
        timeStamp
        unit
        value
        }
      }
    `;

    const variables = { spotConfigurationId, spotType, date: toDateOnly(date)};
    return this.graphqlService.query<SpotTimeSeriesData[]>(query, variables);
  }
}
